// src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header>
      <h1 id="glitch-title">s̶̢̼̭̓͝o̸̭͆̈̊m̴̩̜͚̌ĕ̸̠̫̉w̵̪̲̃̀ĥ̷̲̫́ĕ̸̢͓͖r̸̤̖̊e̵̥̎ ̷̙̘̮̽̇d̷̺̽ȅ̷̩͎͙̀̉e̶̦̰̾̾̈́p̷͕̹͐͘</h1>
      <nav>
        <Link to="/lurking">home</Link>
        <Link to="/browsing">posts</Link>
      </nav>
    </header>
  );
};

export default Header;